import { SubscriptionState } from './types';

export const subscriptionInitialState: SubscriptionState = {
  callbackPath: '/profile',
  productInfo: null,
};
